import * as React from "react";
import { useEffect, useState } from "react";
import Select from "react-select";
import { useUserStore } from "../../../stores/userStore";
import { TypeCategory } from "../../../app/index";
import "./autocomplete.css";
import { FiltersCategoriesProps } from "./filterInterfaces";

const AutocompleteCategories = ({
  currentFilters,
  setCurrentFilters,
  excludeCategories,
}: FiltersCategoriesProps) => {
  const { user } = useUserStore();
  
  // Filtra le categories dalla sessione escludendo quelle specificate
  const filteredCategories = user.categories.filter((category: TypeCategory) => {
    return !excludeCategories.includes(category.key);
  });
  
  const [categories] = useState(filteredCategories);
  const [currentDefault, setDefault] = useState(
    currentFilters.map((category) => ({
      value: category.key,
      label: category.value,
    }))
  );

  const options = categories.map((category) => ({
    value: category.key,
    label: category.value,
  }));

  useEffect(() => {
    setDefault(
      currentFilters.map((category) => ({
        value: category.key,
        label: category.value,
      }))
    );
  }, [currentFilters]);

  const setSelectedCategories = (val: any) => {
    if (setCurrentFilters) {
      setCurrentFilters(
        val.map((item: { value: string; label: string }) => ({
          key: item.value,
          value: item.label,
        }))
      );
    }
  };

  // Mostra la multi-select solo se ci sono più di una categoria disponibile
  if (categories.length <= 1) {
    return null;
  }

  return (
    <Select
      defaultValue={currentDefault}
      className="react-select-container"
      isMulti
      onChange={setSelectedCategories}
      options={options}
      placeholder="Categorie..."
    />
  );
};

export default AutocompleteCategories;
